export const COLUMN_DEFINITIONS = {
  applicantName: {
    displayName: 'Applicant name',
    csvColumnName: 'Applicant name (Required)',
    required: true,
  },
  applicantEmail: {
    displayName: 'Applicant email',
    csvColumnName: 'Applicant email (Recommended)',
    required: false,
  },
  applicantPhone: {
    displayName: 'Applicant phone',
    csvColumnName: 'Applicant phone',
    required: false,
  },
  applicantTags: {
    displayName: 'Applicant tags',
    csvColumnName: 'Applicant tags',
    required: false,
  },
  category: {
    displayName: 'Category',
    csvColumnName: 'Category',
    required: false,
  },
  caseNumber: {
    displayName: 'Case number',
    csvColumnName: 'Case number (Required)',
    required: true,
  },
  caseTags: {
    displayName: 'Case tags',
    csvColumnName: 'Case tags',
    required: false,
  },
} as const
